import { render, staticRenderFns } from "./FormLengkapiAlamat.vue?vue&type=template&id=b812a0ee&scoped=true"
import script from "./FormLengkapiAlamat.vue?vue&type=script&lang=js"
export * from "./FormLengkapiAlamat.vue?vue&type=script&lang=js"
import style0 from "./FormLengkapiAlamat.vue?vue&type=style&index=0&id=b812a0ee&prod&lang=scss"
import style1 from "./FormLengkapiAlamat.vue?vue&type=style&index=1&id=b812a0ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b812a0ee",
  null
  
)

export default component.exports